// extracted by mini-css-extract-plugin
module.exports = {"AdSlotBranding__desktopWrap":"bgc_a","AdSlotBranding__desktop":"bgc_b","AdSlotBranding__mobile":"bgc_c"};